import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import VueQuillEditor from 'vue-quill-editor'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css';
import axios from 'axios'
import md5 from 'blueimp-md5'
import qs from 'qs'
import Lockr from 'lockr'
import moment from "moment"
import _ from 'lodash'
// import echarts from 'echarts'
import _g from './assets/js/global';
import api from './assets/js/http';
import bus from './assets/js/bus';
import Print from './assets/js/print';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {
    checkPermission
} from './assets/js/util'
import {
    Message
} from 'element-ui'
import Watermark from './assets/js/waterMark';
import horizontalScroll from 'el-table-horizontal-scroll'
Vue.use(horizontalScroll)

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as echarts from 'echarts'
import PinyinMatch from 'pinyin-match'
Vue.prototype.$echarts = echarts
Vue.prototype.$PinyinMatch = PinyinMatch
import {
    mixin
} from './assets/js/mixin';
Vue.mixin(mixin)




Vue.prototype.checkPermission = checkPermission
// 本地环境
// axios.defaults.baseURL = 'http://172.17.10.220:6001/bs/'

//测试域名
axios.defaults.baseURL = 'https://idnsknapi.bsl-lj.com/bs/'
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.headers.token = Lockr.get('skinToken')
axios.defaults.timeout = 1000 * 60 * 3
axios.interceptors.request.use(function (config) {
    /*config.data = qs.stringify(config.data)*/
    return config;
}, function (err) {
    return Promise.reject(err);
});

router.beforeEach((to, from, next) => {
    // 部署到服务器中,清除缓存
    const VUE_APP_VERSION = require('../public/version.json').version
    // console.log(VUE_APP_VERSION);
    const vers = window.localStorage.getItem("Version");
    if (VUE_APP_VERSION != vers) {
        window.localStorage.setItem("Version", VUE_APP_VERSION);
        location.reload()
    }
    // token验证
    var token = Lockr.get('skinToken')
    if (!token && to.path !== '/login') {
        Message.error({
            message: '登录超时,请重新登录!'
        });
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        })
    }
    next()
})

router.afterEach((to) => {
    /* 路由发生变化修改页面title */
    // if (to.meta.title) {
    //   changTitle(to.meta.title);
    // }
    //年
    let year = new Date().getFullYear();
    //月份是从0月开始获取的，所以要+1;
    let month = new Date().getMonth() + 1;
    //日
    let day = new Date().getDate();
    let time = year + '.' + month + '.' + day
    if (to.path !== '/login') {
        let userName = Lockr.get("skinUserName");
        Watermark.set(userName + time);
    }
});

Vue.config.productionTip = false
Vue.use(Viewer);

Vue.use(ElementUI);
Vue.use(VueQuillEditor)
Vue.use(Print)
window.axios = axios
window.Lockr = Lockr
window.md5 = md5
window.api = api
window.busPhone = bus
window.echarts = echarts
window.router = router
window.moment = moment
window.bus = new Vue()
window._ = _
window._g = _g

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')